export default "__VITE_ASSET__61de3cda__"